import { useEffect, useState } from "react";
import { Form, Spinner, Accordion, Card, Image, useAccordionButton, Tabs, Tab } from "react-bootstrap";
import "bootstrap-icons/font/bootstrap-icons.css";
import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router-dom";
import {
    ADMINISTRATIVE_APPARATUS_ROUTE,
    ADMINISTRATIVE_COUNCIL_ROUTE,
    PRESIDENTS_MESSAGE_ROUTE,
    REGULATIONS_ROUTE,
    REPORTS_ROUTE,
    SUBDIVISIONS_ROUTE,
} from "../../utils/consts";
import {
    fetchAdministrativeApparatus,
    fetchAdministrativeCouncil,
    fetchBiography,
    fetchMeetings,
    fetchOneOrganization,
    fetchRegulations,
    fetchSpecialCommittees,
    fetchSpecialCommitteesMeets,
    fetchSubdivisions,
    fetchVerbalProcedure,
    removeOneAdministrativeApparatus,
    removeOneAdministrativeCouncil,
    removeOneBiographyStudy,
    removeOneIntership,
    removeOneLanguage,
    removeOneMeetingsFile,
    removeOneMember,
    removeOneOrganization,
    removeOneProfExperience,
    removeOneRegulations,
    removeOneRegulationsFile,
    removeOneSpecialCommitteesMeetsFile,
    removeOneSubdivisions,
    removeOneVerbalProcedureFile,
    updateOneAdministrativeApparatus,
    updateOneAdministrativeCouncil,
    updateOneOrganization,
    updateOneRegulations,
    updateOneSubdivisions,
} from "../../http/navLinksAPI";
import AddAdminModal from "./Modals/AddAdminModal";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import parse from "html-react-parser";
import {
    fetchReports,
    removeOneReports,
    removeOneReportsFile,
    updateOneReports,
} from "../../http/resourcesServicesAPI";

const AdministrationAdmin = observer(() => {
    const navigate = useNavigate();
    const [show, setShow] = useState(false);
    const [administrativeCouncil, setAdministrativeCouncil] = useState(null);
    const [administrativeApparatus, setAdministrativeApparatus] = useState(null);
    const [subdivisions, setSubdivisions] = useState(null);

    const [biography, setBiography] = useState([null]);
    const [organization, setOrganization] = useState([null]);
    const [committees, setCommittees] = useState([null]);
    const [regulations, setRegulations] = useState([null]);
    const [cmbDecisions, setCMBDecisions] = useState([null]);

    // DS

    const [name, setName] = useState("");
    const [fullName, setFullName] = useState("");
    const [phone, setPhone] = useState("");
    const [type, setType] = useState("");
    const [contactPerson, setContactPerson] = useState("");
    const [address, setAddress] = useState("");
    const [article, setArticle] = useState("");

    const [loading, setLoading] = useState(true);
    const [selectedTab, setSelectedTab] = useState("Organigrama");

    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [author, setAuthor] = useState("");
    const [img, setImg] = useState([null]);
    const [files, setFiles] = useState([null]);

    const CustomToggle = ({ children, eventKey }) => {
        const decoratedOnClick = useAccordionButton(eventKey);

        return (
            <button
                className="btn btn-primary d-flex align-items-center mb-xl-1 mx-xl-0 mx-2"
                onClick={decoratedOnClick}>
                {children}
            </button>
        );
    };

    const modules = {
        toolbar: [
            [{ size: ["small", false, "large", "huge"] }],
            ["bold", "italic", "underline", "strike", "blockquote"],
            [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }, { align: [] }],
            ["link", "image"],
            [
                {
                    color: [
                        "#000000",
                        "#e60000",
                        "#ff9900",
                        "#ffff00",
                        "#008a00",
                        "#0066cc",
                        "#9933ff",
                        "#ffffff",
                        "#facccc",
                        "#ffebcc",
                        "#ffffcc",
                        "#cce8cc",
                        "#cce0f5",
                        "#ebd6ff",
                        "#bbbbbb",
                        "#f06666",
                        "#ffc266",
                        "#ffff66",
                        "#66b966",
                        "#66a3e0",
                        "#c285ff",
                        "#888888",
                        "#a10000",
                        "#b26b00",
                        "#b2b200",
                        "#006100",
                        "#0047b2",
                        "#6b24b2",
                        "#444444",
                        "#5c0000",
                        "#663d00",
                        "#666600",
                        "#003700",
                        "#002966",
                        "#3d1466",
                        "custom-color",
                    ],
                },
            ],
        ],
    };

    const formats = [
        "header",
        "height",
        "bold",
        "italic",
        "underline",
        "strike",
        "blockquote",
        "list",
        "color",
        "bullet",
        "indent",
        "link",
        "image",
        "align",
        "size",
    ];

    const editItem = (data) => {
        const id = data.id;
        const formData = new FormData();
        if (title != "") formData.append("title", title);
        if (description != "") formData.append("description", description);
        if (img != null) formData.append("img", img);
        if (author != "") formData.append("author", author);

        // DS

        if (name != "") formData.append("name", name);
        if (fullName != "") formData.append("full_name", fullName);
        if (phone != "") formData.append("phone", phone);
        if (type != "") formData.append("type", type);
        if (address != "") formData.append("address", address);
        if (contactPerson != "") formData.append("contact_person", contactPerson);
        if (article != "") formData.append("article", article);

        if (files.length > 0)
            for (const file of files) {
                formData.append("files", file);
            }

        switch (selectedTab) {
            case "Organigrama":
                updateOneOrganization(formData, id).then(() => window.location.reload());
                break;
            case "Regulamente":
                updateOneReports(formData, id).then(() => window.location.reload());
                break;
            case "Decizii CMB":
                updateOneRegulations(formData, id).then(() => window.location.reload());
                break;
            case "Aparatul Administrativ":
                updateOneAdministrativeApparatus(formData, id).then(() => window.location.reload());
                break;
            case "Consiliul Administrativ":
                updateOneAdministrativeCouncil(formData, id).then(() => window.location.reload());
                break;
            case "Subdiviziunile":
                updateOneSubdivisions(formData, id).then(() => window.location.reload());
                break;
        }
    };

    const removeItem = (item) => {
        const id = item.id;
        switch (selectedTab) {
            case "Organigrama":
                removeOneOrganization(id).then(() => window.location.reload());
                break;
            case "Regulamente":
                removeOneReports(id).then(() => window.location.reload());
                break;
            case "Decizii CMB":
                removeOneRegulations(id).then(() => window.location.reload());
                break;
            case "Aparatul Administrativ":
                removeOneAdministrativeApparatus(id).then(() => window.location.reload());
                break;
            case "Consiliul Administrativ":
                removeOneAdministrativeCouncil(id).then(() => window.location.reload());
                break;
            case "Subdiviziunile":
                removeOneSubdivisions(id).then(() => window.location.reload());
                break;
        }
    };

    const removeItemFile = (item) => {
        const id = item.id;
        switch (selectedTab) {
            case "Regulamente":
                removeOneReportsFile(id).then(() => window.location.reload());
                break;
            case "Decizii CMB":
                removeOneRegulationsFile(id).then(() => window.location.reload());
                break;
            case "Sedintele":
                removeOneMeetingsFile(id).then(() => window.location.reload());
                break;
            case "Procese Verbale":
                removeOneVerbalProcedureFile(id).then(() => window.location.reload());
                break;
            case "Sedinte Comisii de Specialitate":
                removeOneSpecialCommitteesMeetsFile(id).then(() => window.location.reload());
                break;
        }
    };

    const selectFile = (e) => {
        setImg(e.target.files[0]);
    };

    const selectMultipleFiles = (e) => {
        setFiles(e.target.files);
    };

    useEffect(() => {
        fetchBiography().then((data) => {
            setBiography(data);
        });
        fetchOneOrganization(1).then((data) => {
            setOrganization(data);
        });
        fetchSpecialCommittees(1).then((data) => {
            setCommittees(data);
        });
        fetchRegulations().then((data) => setRegulations(data));
        fetchAdministrativeCouncil().then((data) => {
            setAdministrativeCouncil(data);
        });
        fetchAdministrativeApparatus().then((data) => setAdministrativeApparatus(data));
        fetchReports().then((data) => setCMBDecisions(data));
        fetchSubdivisions()
            .then((data) => setSubdivisions(data))
            .finally(() => setLoading(false));
    }, []);

    if (loading) {
        return (
            <div className="d-flex align-items-center justify-content-center py-5">
                <Spinner animation={"grow"} />
            </div>
        );
    }

    return (
        <div className="d-flex flex-column bg-white r-corner-radius w-100">
            <div className="d-flex justify-content-between align-items-center font-2 fw-bold text-primary shadow-sm ps-3">
                <span>Administrație</span>
                <button
                    className="btn btn-primary r-u-corner-radius"
                    style={{ height: 70, width: 70 }}
                    onClick={() => setShow(true)}>
                    <i className="bi bi-plus-circle icon-2" />
                </button>
            </div>
            <div className="d-flex flex-column px-2 pt-3">
                <Tabs
                    defaultActiveKey="Organigrama"
                    id="uncontrolled-tab-example"
                    className="d-flex justify-content-center mb-3 text-primary fw-bold"
                    onSelect={(e) => setSelectedTab(e)}>
                    <Tab eventKey="Organigrama" title="Organigrama">
                        <div className="d-flex flex-column">
                            <Accordion className="pb-4">
                                {organization ? (
                                    <div className="shadow-sm border-0 my-2 px-4 rounded">
                                        <div className="d-flex flex-column">
                                            <div className="d-flex flex-xl-row flex-column align-items-center justify-content-between  p-3">
                                                <div className="d-flex flex-xl-row flex column align-items-center">
                                                    {organization.img ? (
                                                        <Image
                                                            className="rounded"
                                                            src={process.env.REACT_APP_API_URL + organization.img}
                                                            style={{ maxHeight: "30vh" }}
                                                        />
                                                    ) : null}
                                                    <div className="d-flex flex-column  ps-xl-4">
                                                        <a
                                                            role="button"
                                                            href={PRESIDENTS_MESSAGE_ROUTE}
                                                            className="text-decoration-none text-primary">
                                                            <Card.Title>{organization.title}</Card.Title>
                                                        </a>
                                                        {organization.description ? (
                                                            <div className="truncate">
                                                                {parse(organization.description)}
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className="d-flex flex-xl-column flex-row justify-content-around py-xl-0 py-3">
                                                    <CustomToggle
                                                        eventKey="organization"
                                                        onClick={() => {
                                                            useAccordionButton("organization");
                                                        }}>
                                                        <i className="bi bi-pencil-square icon-2 pe-2" />
                                                        <span>Edit</span>
                                                    </CustomToggle>
                                                    <button
                                                        className="btn btn-primary d-flex align-items-center mx-xl-0 mx-2"
                                                        onClick={() => removeItem(organization)}>
                                                        <i className="bi bi-x-circle icon-2 pe-2" />
                                                        <span>Remove</span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <Accordion.Collapse eventKey="organization">
                                            <div className="d-flex flex-column justify-content-around px-4 py-4 border-top">
                                                <div className="d-flex flex-column justify-content-around px-4 py-4">
                                                    <span className="text-primary  font-2 py-2 ps-1">Denumire</span>
                                                    <Form.Control
                                                        aria-label="Title"
                                                        placeholder={organization.title}
                                                        value={title}
                                                        onChange={(e) => {
                                                            setTitle(e.target.value);
                                                        }}
                                                    />
                                                    <span className="text-primary  font-2 py-2 ps-1">Descriere</span>
                                                    <ReactQuill
                                                        theme="snow"
                                                        value={description}
                                                        placeholder={organization.description}
                                                        modules={modules}
                                                        formats={formats}
                                                        onChange={setDescription}
                                                    />
                                                    <span className="text-primary  font-2 py-2 ps-1">Fotografie</span>
                                                    <Form.Control
                                                        type={"file"}
                                                        onChange={selectFile}
                                                        aria-label="PageTitle"
                                                        aria-describedby="basic-addon"
                                                    />
                                                </div>
                                                <button
                                                    className="btn btn-primary d-flex align-items-center justify-content-center mx-xl-0 my-4"
                                                    onClick={() => editItem(organization)}>
                                                    <i className="bi bi-check icon-2 pe-2" />
                                                    <span>Confirm</span>
                                                </button>
                                            </div>
                                        </Accordion.Collapse>
                                    </div>
                                ) : null}
                            </Accordion>
                        </div>
                    </Tab>
                    <Tab eventKey="Regulamente" title="Regulamente">
                        <div className="d-flex flex-column">
                            <Accordion className="pb-4">
                                {cmbDecisions.count > 0
                                    ? cmbDecisions.rows.map((item, idx) => (
                                          <div key={idx} className="shadow-sm border-0 my-2 px-4 rounded">
                                              <div className="d-flex flex-column">
                                                  <div className="d-flex flex-xl-row flex-column align-items-center justify-content-between  p-3">
                                                      <div className="d-flex flex-xl-row flex column align-items-center">
                                                          {item.img ? (
                                                              <Image
                                                                  className="rounded"
                                                                  src={process.env.REACT_APP_API_URL + item.img}
                                                                  style={{ maxHeight: "30vh" }}
                                                              />
                                                          ) : null}
                                                          <div className="d-flex flex-column  ps-xl-4">
                                                              <a
                                                                  role="button"
                                                                  onClick={() =>
                                                                      navigate(REPORTS_ROUTE + "/" + item.id)
                                                                  }
                                                                  className="text-decoration-none text-primary">
                                                                  <Card.Title className="truncate">
                                                                      {item.title}
                                                                  </Card.Title>
                                                              </a>
                                                              {item.description ? (
                                                                  <div className="truncate">
                                                                      {parse(item.description)}
                                                                  </div>
                                                              ) : null}
                                                          </div>
                                                      </div>
                                                      <div className="d-flex flex-xl-column flex-row justify-content-around py-xl-0 py-3">
                                                          <CustomToggle
                                                              eventKey={idx}
                                                              onClick={() => {
                                                                  useAccordionButton({ idx });
                                                              }}>
                                                              <i className="bi bi-pencil-square icon-2 pe-2" />
                                                              <span>Edit</span>
                                                          </CustomToggle>
                                                          <button
                                                              className="btn btn-primary d-flex align-items-center mx-xl-0 mx-2"
                                                              onClick={() => removeItem(item)}>
                                                              <i className="bi bi-x-circle icon-2 pe-2" />
                                                              <span>Remove</span>
                                                          </button>
                                                      </div>
                                                  </div>
                                              </div>
                                              <Accordion.Collapse eventKey={idx}>
                                                  <div className="d-flex flex-column justify-content-around px-4 py-4 border-top">
                                                      <div className="d-flex flex-column justify-content-around px-4 py-4">
                                                          <span className="text-primary  font-2 py-2 ps-1">
                                                              Denumire
                                                          </span>
                                                          <Form.Control
                                                              aria-label="Title"
                                                              placeholder={item.title}
                                                              value={title}
                                                              onChange={(e) => {
                                                                  setTitle(e.target.value);
                                                              }}
                                                          />
                                                          <span className="text-primary  font-2 py-2 ps-1">
                                                              Descriere
                                                          </span>
                                                          <ReactQuill
                                                              theme="snow"
                                                              value={description}
                                                              placeholder={item.description}
                                                              modules={modules}
                                                              formats={formats}
                                                              onChange={setDescription}
                                                          />
                                                          <span className="text-primary  font-2 py-2 ps-1">
                                                              Fotografie
                                                          </span>
                                                          <Form.Control
                                                              type={"file"}
                                                              onChange={selectFile}
                                                              aria-label="PageTitle"
                                                              aria-describedby="basic-addon"
                                                          />
                                                          <span className="text-primary  font-2 py-2 ps-1">
                                                              Documente
                                                          </span>
                                                          <Form.Control
                                                              type={"file"}
                                                              onChange={selectMultipleFiles}
                                                              aria-label="PageTitle"
                                                              aria-describedby="basic-addon"
                                                              multiple
                                                          />
                                                          {item.reports_files.length > 0
                                                              ? item.reports_files.map((sub_item, sub_idx) => (
                                                                    <div
                                                                        key={sub_idx}
                                                                        className="d-flex flex-row justify-content-around align-items-center text-primary text-decoration-none py-4">
                                                                        <div className="d-flex align-items-center">
                                                                            <i
                                                                                className={`bi bi-filetype-${sub_item.doc_type} icon-2 text-primary rounded ms-4 px-2 text-primary`}
                                                                            />
                                                                            <a
                                                                                href={
                                                                                    process.env.REACT_APP_API_URL +
                                                                                    sub_item.doc
                                                                                }>
                                                                                <span
                                                                                    className="text-wrap"
                                                                                    style={{ textAlign: "justify" }}>
                                                                                    {sub_item.doc.substring(
                                                                                        0,
                                                                                        sub_item.doc.lastIndexOf(".")
                                                                                    )}
                                                                                </span>
                                                                            </a>
                                                                        </div>
                                                                        <button
                                                                            className="btn btn-primary"
                                                                            onClick={() => removeItemFile(sub_item)}>
                                                                            <i className="bi bi-x-circle font-2"></i>
                                                                        </button>
                                                                    </div>
                                                                ))
                                                              : null}
                                                      </div>
                                                      <button
                                                          className="btn btn-primary d-flex align-items-center justify-content-center mx-xl-0 my-4"
                                                          onClick={() => editItem(item)}>
                                                          <i className="bi bi-check icon-2 pe-2" />
                                                          <span>Confirm</span>
                                                      </button>
                                                  </div>
                                              </Accordion.Collapse>
                                          </div>
                                      ))
                                    : null}
                            </Accordion>
                        </div>
                    </Tab>
                    <Tab eventKey="Decizii CMB" title="Decizii CMB">
                        <div className="d-flex flex-column">
                            <Accordion className="pb-4">
                                {regulations.count > 0
                                    ? regulations.rows.map((item, idx) => (
                                          <div key={idx} className="shadow-sm border-0 my-2 px-4 rounded">
                                              <div className="d-flex flex-column">
                                                  <div className="d-flex flex-xl-row flex-column align-items-center justify-content-between  p-3">
                                                      <div className="d-flex flex-xl-row flex column align-items-center">
                                                          {item.img ? (
                                                              <Image
                                                                  className="rounded"
                                                                  src={process.env.REACT_APP_API_URL + item.img}
                                                                  style={{ maxHeight: "30vh" }}
                                                              />
                                                          ) : null}
                                                          <div className="d-flex flex-column  ps-xl-4">
                                                              <a
                                                                  role="button"
                                                                  onClick={() =>
                                                                      navigate(REGULATIONS_ROUTE + "/" + item.id)
                                                                  }
                                                                  className="text-decoration-none text-primary">
                                                                  <Card.Title className="truncate">
                                                                      {item.title}
                                                                  </Card.Title>
                                                              </a>
                                                              {item.description ? (
                                                                  <div className="truncate">
                                                                      {parse(item.description)}
                                                                  </div>
                                                              ) : null}
                                                          </div>
                                                      </div>
                                                      <div className="d-flex flex-xl-column flex-row justify-content-around py-xl-0 py-3">
                                                          <CustomToggle
                                                              eventKey={idx}
                                                              onClick={() => {
                                                                  useAccordionButton({ idx });
                                                              }}>
                                                              <i className="bi bi-pencil-square icon-2 pe-2" />
                                                              <span>Edit</span>
                                                          </CustomToggle>
                                                          <button
                                                              className="btn btn-primary d-flex align-items-center mx-xl-0 mx-2"
                                                              onClick={() => removeItem(item)}>
                                                              <i className="bi bi-x-circle icon-2 pe-2" />
                                                              <span>Remove</span>
                                                          </button>
                                                      </div>
                                                  </div>
                                              </div>
                                              <Accordion.Collapse eventKey={idx}>
                                                  <div className="d-flex flex-column justify-content-around px-4 py-4 border-top">
                                                      <div className="d-flex flex-column justify-content-around px-4 py-4">
                                                          <span className="text-primary  font-2 py-2 ps-1">
                                                              Denumire
                                                          </span>
                                                          <Form.Control
                                                              aria-label="Title"
                                                              placeholder={item.title}
                                                              value={title}
                                                              onChange={(e) => {
                                                                  setTitle(e.target.value);
                                                              }}
                                                          />
                                                          <span className="text-primary  font-2 py-2 ps-1">
                                                              Descriere
                                                          </span>
                                                          <ReactQuill
                                                              theme="snow"
                                                              value={description}
                                                              placeholder={item.description}
                                                              modules={modules}
                                                              formats={formats}
                                                              onChange={setDescription}
                                                          />
                                                          <span className="text-primary  font-2 py-2 ps-1">
                                                              Fotografie
                                                          </span>
                                                          <Form.Control
                                                              type={"file"}
                                                              onChange={selectFile}
                                                              aria-label="PageTitle"
                                                              aria-describedby="basic-addon"
                                                          />
                                                          <span className="text-primary  font-2 py-2 ps-1">
                                                              Documente
                                                          </span>
                                                          <Form.Control
                                                              type={"file"}
                                                              onChange={selectMultipleFiles}
                                                              aria-label="PageTitle"
                                                              aria-describedby="basic-addon"
                                                              multiple
                                                          />
                                                          {item.regulations_files.length > 0
                                                              ? item.regulations_files.map((sub_item, sub_idx) => (
                                                                    <div
                                                                        key={sub_idx}
                                                                        className="d-flex flex-row justify-content-around align-items-center text-primary text-decoration-none py-4">
                                                                        <div className="d-flex align-items-center">
                                                                            <i
                                                                                className={`bi bi-filetype-${sub_item.doc_type} icon-2 text-primary rounded ms-4 px-2 text-primary`}
                                                                            />
                                                                            <a
                                                                                href={
                                                                                    process.env.REACT_APP_API_URL +
                                                                                    sub_item.doc
                                                                                }>
                                                                                <span
                                                                                    className="text-wrap"
                                                                                    style={{ textAlign: "justify" }}>
                                                                                    {sub_item.doc.substring(
                                                                                        0,
                                                                                        sub_item.doc.lastIndexOf(".")
                                                                                    )}
                                                                                </span>
                                                                            </a>
                                                                        </div>
                                                                        <button
                                                                            className="btn btn-primary"
                                                                            onClick={() => removeItemFile(sub_item)}>
                                                                            <i className="bi bi-x-circle font-2"></i>
                                                                        </button>
                                                                    </div>
                                                                ))
                                                              : null}
                                                      </div>
                                                      <button
                                                          className="btn btn-primary d-flex align-items-center justify-content-center mx-xl-0 my-4"
                                                          onClick={() => editItem(item)}>
                                                          <i className="bi bi-check icon-2 pe-2" />
                                                          <span>Confirm</span>
                                                      </button>
                                                  </div>
                                              </Accordion.Collapse>
                                          </div>
                                      ))
                                    : null}
                            </Accordion>
                        </div>
                    </Tab>
                    <Tab eventKey="Consiliul Administrativ" title="Consiliul Administrativ">
                        <div className="d-flex flex-column">
                            <Accordion className="pb-4">
                                {administrativeCouncil
                                    ? administrativeCouncil.rows.map((item, idx) => (
                                          <div key={idx} className="shadow-sm border-0 my-2 px-4 rounded">
                                              <div className="d-flex flex-column">
                                                  <div className="d-flex flex-xl-row flex-column align-items-center justify-content-between  p-3">
                                                      <div className="d-flex flex-xl-row flex column align-items-center">
                                                          <div className="d-flex flex-column  ps-xl-4">
                                                              <a
                                                                  role="button"
                                                                  href={ADMINISTRATIVE_COUNCIL_ROUTE}
                                                                  className="text-decoration-none text-primary">
                                                                  <Card.Title>{item.full_name}</Card.Title>
                                                              </a>
                                                              <div>
                                                                  <span>{item.phone}</span>
                                                              </div>
                                                          </div>
                                                      </div>
                                                      <div className="d-flex flex-xl-column flex-row justify-content-around py-xl-0 py-3">
                                                          <CustomToggle
                                                              eventKey={idx}
                                                              onClick={() => {
                                                                  useAccordionButton({ idx });
                                                              }}>
                                                              <i className="bi bi-pencil-square icon-2 pe-2" />
                                                              <span>Edit</span>
                                                          </CustomToggle>
                                                          <button
                                                              className="btn btn-primary d-flex align-items-center mx-xl-0 mx-2"
                                                              onClick={() => removeItem(item)}>
                                                              <i className="bi bi-x-circle icon-2 pe-2" />
                                                              <span>Remove</span>
                                                          </button>
                                                      </div>
                                                  </div>
                                              </div>
                                              <Accordion.Collapse eventKey={idx}>
                                                  <div className="d-flex flex-column justify-content-around px-4 py-4 border-top">
                                                      <div className="d-flex flex-column justify-content-around px-4 py-4">
                                                          <span className="text-primary  font-2 py-2 ps-1">
                                                              Responsabil
                                                          </span>
                                                          <Form.Control
                                                              aria-label="Title"
                                                              placeholder={item.full_name}
                                                              value={fullName}
                                                              onChange={(e) => {
                                                                  setFullName(e.target.value);
                                                              }}
                                                          />
                                                          <span className="text-primary  font-2 py-2 ps-1">
                                                              Nr. de Telefon
                                                          </span>
                                                          <Form.Control
                                                              aria-label="Phone"
                                                              placeholder={item.phone}
                                                              value={phone}
                                                              onChange={(e) => {
                                                                  setPhone(e.target.value);
                                                              }}
                                                          />
                                                      </div>
                                                      <button
                                                          className="btn btn-primary d-flex align-items-center justify-content-center mx-xl-0 my-4"
                                                          onClick={() => editItem(item)}>
                                                          <i className="bi bi-check icon-2 pe-2" />
                                                          <span>Confirm</span>
                                                      </button>
                                                  </div>
                                              </Accordion.Collapse>
                                          </div>
                                      ))
                                    : null}
                            </Accordion>
                        </div>
                    </Tab>
                    <Tab eventKey="Aparatul Administrativ" title="Aparatul Administrativ">
                        <div className="d-flex flex-column">
                            <Accordion className="pb-4">
                                {administrativeApparatus
                                    ? administrativeApparatus.rows.map((item, idx) => (
                                          <div key={idx} className="shadow-sm border-0 my-2 px-4 rounded">
                                              <div className="d-flex flex-column">
                                                  <div className="d-flex flex-xl-row flex-column align-items-center justify-content-between  p-3">
                                                      <div className="d-flex flex-xl-row flex column align-items-center">
                                                          <div className="d-flex flex-column  ps-xl-4">
                                                              <a
                                                                  role="button"
                                                                  href={ADMINISTRATIVE_APPARATUS_ROUTE}
                                                                  className="text-decoration-none text-primary">
                                                                  <Card.Title>{item.full_name}</Card.Title>
                                                              </a>
                                                              <div>
                                                                  <span>{item.phone}</span>
                                                              </div>
                                                          </div>
                                                      </div>
                                                      <div className="d-flex flex-xl-column flex-row justify-content-around py-xl-0 py-3">
                                                          <CustomToggle
                                                              eventKey={idx}
                                                              onClick={() => {
                                                                  useAccordionButton({ idx });
                                                              }}>
                                                              <i className="bi bi-pencil-square icon-2 pe-2" />
                                                              <span>Edit</span>
                                                          </CustomToggle>
                                                          <button
                                                              className="btn btn-primary d-flex align-items-center mx-xl-0 mx-2"
                                                              onClick={() => removeItem(item)}>
                                                              <i className="bi bi-x-circle icon-2 pe-2" />
                                                              <span>Remove</span>
                                                          </button>
                                                      </div>
                                                  </div>
                                              </div>
                                              <Accordion.Collapse eventKey={idx}>
                                                  <div className="d-flex flex-column justify-content-around px-4 py-4 border-top">
                                                      <div className="d-flex flex-column justify-content-around px-4 py-4">
                                                          <span className="text-primary  font-2 py-2 ps-1">
                                                              Responsabil
                                                          </span>
                                                          <Form.Control
                                                              aria-label="Title"
                                                              placeholder={item.full_name}
                                                              value={fullName}
                                                              onChange={(e) => {
                                                                  setFullName(e.target.value);
                                                              }}
                                                          />
                                                          <span className="text-primary  font-2 py-2 ps-1">
                                                              Nr. de Telefon
                                                          </span>
                                                          <Form.Control
                                                              aria-label="Phone"
                                                              placeholder={item.phone}
                                                              value={phone}
                                                              onChange={(e) => {
                                                                  setPhone(e.target.value);
                                                              }}
                                                          />
                                                      </div>
                                                      <button
                                                          className="btn btn-primary d-flex align-items-center justify-content-center mx-xl-0 my-4"
                                                          onClick={() => editItem(item)}>
                                                          <i className="bi bi-check icon-2 pe-2" />
                                                          <span>Confirm</span>
                                                      </button>
                                                  </div>
                                              </Accordion.Collapse>
                                          </div>
                                      ))
                                    : null}
                            </Accordion>
                        </div>
                    </Tab>
                    <Tab eventKey="Subdiviziunile" title="Subdiviziunile">
                        <div className="d-flex flex-column">
                            <Accordion className="pb-4">
                                {subdivisions
                                    ? subdivisions.rows.map((item, idx) => (
                                          <div key={idx} className="shadow-sm border-0 my-2 px-4 rounded">
                                              <div className="d-flex flex-column">
                                                  <div className="d-flex flex-xl-row flex-column align-items-center justify-content-between  p-3">
                                                      <div className="d-flex flex-xl-row flex column align-items-center">
                                                          <div className="d-flex flex-column  ps-xl-4">
                                                              <a
                                                                  role="button"
                                                                  href={SUBDIVISIONS_ROUTE}
                                                                  className="text-decoration-none text-primary">
                                                                  <Card.Title>{item.name}</Card.Title>
                                                              </a>
                                                              <div>
                                                                  <span>{item.full_name}</span>
                                                                  <span>{item.phone}</span>
                                                              </div>
                                                          </div>
                                                      </div>
                                                      <div className="d-flex flex-xl-column flex-row justify-content-around py-xl-0 py-3">
                                                          <CustomToggle
                                                              eventKey={idx}
                                                              onClick={() => {
                                                                  useAccordionButton({ idx });
                                                              }}>
                                                              <i className="bi bi-pencil-square icon-2 pe-2" />
                                                              <span>Edit</span>
                                                          </CustomToggle>
                                                          <button
                                                              className="btn btn-primary d-flex align-items-center mx-xl-0 mx-2"
                                                              onClick={() => removeItem(item)}>
                                                              <i className="bi bi-x-circle icon-2 pe-2" />
                                                              <span>Remove</span>
                                                          </button>
                                                      </div>
                                                  </div>
                                              </div>
                                              <Accordion.Collapse eventKey={idx}>
                                                  <div className="d-flex flex-column justify-content-around px-4 py-4 border-top">
                                                      <div className="d-flex flex-column justify-content-around px-4 py-4">
                                                          <span className="text-primary  font-2 py-2 ps-1">
                                                              Denumire
                                                          </span>
                                                          <Form.Control
                                                              aria-label="Title"
                                                              placeholder={item.name}
                                                              value={name}
                                                              onChange={(e) => {
                                                                  setName(e.target.value);
                                                              }}
                                                          />
                                                          <span className="text-primary  font-2 py-2 ps-1">
                                                              Responsabil
                                                          </span>
                                                          <Form.Control
                                                              aria-label="Title"
                                                              placeholder={item.full_name}
                                                              value={fullName}
                                                              onChange={(e) => {
                                                                  setFullName(e.target.value);
                                                              }}
                                                          />
                                                          <span className="text-primary  font-2 py-2 ps-1">
                                                              Nr. de Telefon
                                                          </span>
                                                          <Form.Control
                                                              aria-label="Phone"
                                                              placeholder={item.phone}
                                                              value={phone}
                                                              onChange={(e) => {
                                                                  setPhone(e.target.value);
                                                              }}
                                                          />
                                                      </div>
                                                      <button
                                                          className="btn btn-primary d-flex align-items-center justify-content-center mx-xl-0 my-4"
                                                          onClick={() => editItem(item)}>
                                                          <i className="bi bi-check icon-2 pe-2" />
                                                          <span>Confirm</span>
                                                      </button>
                                                  </div>
                                              </Accordion.Collapse>
                                          </div>
                                      ))
                                    : null}
                            </Accordion>
                        </div>
                    </Tab>
                </Tabs>
            </div>
            <AddAdminModal show={show} onHide={() => setShow(false)} selectedTab={selectedTab} />
        </div>
    );
});

export default AdministrationAdmin;
